import { render, staticRenderFns } from "./ChainsBonusGameForm.vue?vue&type=template&id=0edeb3fc&scoped=true&lang=pug&"
import script from "./ChainsBonusGameForm.vue?vue&type=script&lang=js&"
export * from "./ChainsBonusGameForm.vue?vue&type=script&lang=js&"
import style0 from "./ChainsBonusGameForm.vue?vue&type=style&index=0&id=0edeb3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edeb3fc",
  null
  
)

export default component.exports